import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_heat-dispatch/artifacts/5ljah6z6_image.png";

export default function Navbar() {
  return (
    <nav
      className="sticky top-0 z-40 bg-brand-navy text-white border-b-4 border-brand-red"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-36 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 group shrink-0" data-testid="nav-home-logo">
          <img
            src={LOGO_URL}
            alt="McFly's Fuel Inc."
            className="h-28 w-auto block"
            style={{ mixBlendMode: "screen" }}
          />
          <div className="leading-tight hidden md:block">
            <div className="font-heading text-xl tracking-tight text-white">McFly's Fuel Inc.</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-brand-gold font-bold">Heating Oil · Long Island</div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-7 text-sm font-heading tracking-wide">
          <a href="#why" className="text-white/80 hover:text-brand-gold transition-colors" data-testid="nav-why">WHY US</a>
          <a href="#service-area" className="text-white/80 hover:text-brand-gold transition-colors" data-testid="nav-service-area">AREA</a>
          <a href="#order" className="text-white/80 hover:text-brand-gold transition-colors" data-testid="nav-order">REQUEST QUOTE</a>
          <a href="#reviews" className="text-white/80 hover:text-brand-gold transition-colors" data-testid="nav-reviews">REVIEWS</a>
        </div>

        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <a
            href="tel:6313723526"
            className="flex items-center gap-2 bg-brand-red hover:bg-brand-redDark text-white px-4 py-2 font-heading tracking-wide border-2 border-white/10 transition-colors"
            data-testid="nav-call-btn"
          >
            <Phone size={16} /> 631-372-3526
          </a>
        </div>
      </div>
    </nav>
  );
}
